/**
 * @flow
 * @relayHash 746a1f0d042e948511816407c7264e79
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type HeaderRefetchQueryResponse = {|
  +viewer: ?{| |};
|};
*/


/*
query HeaderRefetchQuery(
  $userId: String!
  $userIds: [String]!
  $hasUserId: Boolean!
  $showMarketingMessages: Boolean!
  $fetchMarketingMessagesTransactions: Boolean!
) {
  viewer {
    ...Header_viewer
    id
  }
}

fragment Header_viewer on Viewer {
  ...TopBar_viewer
  allTransactions: transactions(buyerId: $userIds, first: 0) @include(if: $hasUserId) {
    totalResults
  }
  initiatedTransactions: transactions(buyerId: $userIds, viewName: "buyerTracking.initiated", first: 0) @include(if: $hasUserId) {
    totalResults
  }
  submittedTransactions: transactions(buyerId: $userIds, viewName: "buyerTracking.submitted", first: 0) @include(if: $hasUserId) {
    totalResults
  }
  confirmedTransactionsMostRecent: transactions(buyerId: $userIds, sort: "createdDate asc", viewName: "buyerTracking.confirmed", first: 1) @include(if: $hasUserId) {
    totalResults
    edges {
      node {
        mostRecentOffer {
          createdDate
          subTotalAmount {
            convertedAmounts {
              USD
            }
          }
          id
        }
        id
      }
    }
  }
  ... on Viewer @include(if: $hasUserId) {
    tradeChatEmail: userRelationships(userIds: $userIds, relationshipType: VIP) {
      userDataB {
        __typename
        ... on VipRepData {
          email
        }
      }
      id
    }
    vipChatEmail: userRelationships(userIds: $userIds, relationshipType: TRADE) {
      userDataB {
        __typename
        ... on TradeRepData {
          email
        }
      }
      id
    }
  }
  user(userId: $userId) @include(if: $hasUserId) {
    firstSessionDate
    isTrade: hasPermission(name: "B_TRADE_CHECKOUT")
    hasVipPermission: hasPermission(name: "B_VIP_CHECKOUT")
    profile {
      email
      zipCode
      currency
    }
    serviceId
    totalMessagesToDealers
    tradeFirm {
      serviceId
      tier
      id
    }
    verifiedTradeStatus
    isPromoCodeEligible(code: "SAVE15")
    isVip
    createdDate
    isVerifiedTrade
    ... on User @include(if: $showMarketingMessages) {
      ...MessageBanner_user
    }
    ...TopBar_user
    id
  }
  ... on Viewer @include(if: $showMarketingMessages) {
    ...MessageBanner_viewer
  }
}

fragment TopBar_viewer on Viewer {
  ...CartNav_viewer
  ...Notifications_initialViewer
}

fragment MessageBanner_user on User {
  isVip
  isVerifiedTrade
  verifiedTradeStatus
  verifiedTradeSubStatus
  tradeFirm {
    loyalty {
      status
    }
    id
  }
}

fragment TopBar_user on User {
  ...AccountNav_user
  ...CartNav_user
  ...Notifications_user
}

fragment MessageBanner_viewer on Viewer {
  allTransactions: transactions(buyerId: $userIds, first: 0) @include(if: $fetchMarketingMessagesTransactions) {
    totalResults
  }
  initiatedTransactions: transactions(buyerId: $userIds, viewName: "buyerTracking.initiated", first: 0) @include(if: $fetchMarketingMessagesTransactions) {
    totalResults
  }
  submittedTransactions: transactions(buyerId: $userIds, viewName: "buyerTracking.submitted", first: 0) @include(if: $fetchMarketingMessagesTransactions) {
    totalResults
  }
  confirmedTransactions: transactions(buyerId: $userIds, sort: "createdDate asc", viewName: "buyerTracking.confirmed", first: 0) @include(if: $fetchMarketingMessagesTransactions) {
    totalResults
  }
}

fragment AccountNav_user on User {
  profile {
    firstName
  }
  conversationSummary {
    totalUnreadConversationCount
  }
  tradeFirm {
    loyalty {
      status
    }
    id
  }
}

fragment CartNav_user on User {
  profile {
    currency
  }
}

fragment Notifications_user on User {
  isPromoCodeEligible(code: "SAVE15")
}

fragment CartNav_viewer on Viewer {
  portfolios(userIds: $userIds, portfolioTypes: [CART], first: 1) @include(if: $hasUserId) {
    edges {
      node {
        items(first: 3) {
          totalResults
        }
        id
      }
    }
  }
}

fragment Notifications_initialViewer on Viewer {
  conversations(filter: "showUnreadOnly") @include(if: $hasUserId) {
    metadata {
      lastUnreadMessageDate
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "userId",
        "type": "String!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "userIds",
        "type": "[String]!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "hasUserId",
        "type": "Boolean!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "showMarketingMessages",
        "type": "Boolean!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "fetchMarketingMessagesTransactions",
        "type": "Boolean!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "HeaderRefetchQuery",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Header_viewer",
            "args": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "HeaderRefetchQuery",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "userId",
        "type": "String!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "userIds",
        "type": "[String]!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "hasUserId",
        "type": "Boolean!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "showMarketingMessages",
        "type": "Boolean!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "fetchMarketingMessagesTransactions",
        "type": "Boolean!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "HeaderRefetchQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "showMarketingMessages",
            "selections": [
              {
                "kind": "InlineFragment",
                "type": "Viewer",
                "selections": [
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "fetchMarketingMessagesTransactions",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": "allTransactions",
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "buyerId",
                            "variableName": "userIds",
                            "type": "[String]"
                          },
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 0,
                            "type": "Int"
                          }
                        ],
                        "concreteType": "TransactionConnection",
                        "name": "transactions",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "totalResults",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": "initiatedTransactions",
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "buyerId",
                            "variableName": "userIds",
                            "type": "[String]"
                          },
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 0,
                            "type": "Int"
                          },
                          {
                            "kind": "Literal",
                            "name": "viewName",
                            "value": "buyerTracking.initiated",
                            "type": "String"
                          }
                        ],
                        "concreteType": "TransactionConnection",
                        "name": "transactions",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "totalResults",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": "submittedTransactions",
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "buyerId",
                            "variableName": "userIds",
                            "type": "[String]"
                          },
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 0,
                            "type": "Int"
                          },
                          {
                            "kind": "Literal",
                            "name": "viewName",
                            "value": "buyerTracking.submitted",
                            "type": "String"
                          }
                        ],
                        "concreteType": "TransactionConnection",
                        "name": "transactions",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "totalResults",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": "confirmedTransactions",
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "buyerId",
                            "variableName": "userIds",
                            "type": "[String]"
                          },
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 0,
                            "type": "Int"
                          },
                          {
                            "kind": "Literal",
                            "name": "sort",
                            "value": "createdDate asc",
                            "type": "String"
                          },
                          {
                            "kind": "Literal",
                            "name": "viewName",
                            "value": "buyerTracking.confirmed",
                            "type": "String"
                          }
                        ],
                        "concreteType": "TransactionConnection",
                        "name": "transactions",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "totalResults",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1,
                    "type": "Int"
                  },
                  {
                    "kind": "Literal",
                    "name": "portfolioTypes",
                    "value": [
                      "CART"
                    ],
                    "type": "[PortfolioTypes]"
                  },
                  {
                    "kind": "Variable",
                    "name": "userIds",
                    "variableName": "userIds",
                    "type": "[String]"
                  }
                ],
                "concreteType": "PortfoliosConnection",
                "name": "portfolios",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "PortfoliosEdge",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "PortfolioV2",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 3,
                                "type": "Int"
                              }
                            ],
                            "concreteType": "PortfolioItemsConnection",
                            "name": "items",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "totalResults",
                                "storageKey": null
                              }
                            ],
                            "storageKey": "items{\"first\":3}"
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "id",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": "showUnreadOnly",
                    "type": "String"
                  }
                ],
                "concreteType": "ConversationConnection",
                "name": "conversations",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "ConversationMetadata",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "lastUnreadMessageDate",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "conversations{\"filter\":\"showUnreadOnly\"}"
              },
              {
                "kind": "LinkedField",
                "alias": "allTransactions",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "buyerId",
                    "variableName": "userIds",
                    "type": "[String]"
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 0,
                    "type": "Int"
                  }
                ],
                "concreteType": "TransactionConnection",
                "name": "transactions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "totalResults",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": "initiatedTransactions",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "buyerId",
                    "variableName": "userIds",
                    "type": "[String]"
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 0,
                    "type": "Int"
                  },
                  {
                    "kind": "Literal",
                    "name": "viewName",
                    "value": "buyerTracking.initiated",
                    "type": "String"
                  }
                ],
                "concreteType": "TransactionConnection",
                "name": "transactions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "totalResults",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": "submittedTransactions",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "buyerId",
                    "variableName": "userIds",
                    "type": "[String]"
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 0,
                    "type": "Int"
                  },
                  {
                    "kind": "Literal",
                    "name": "viewName",
                    "value": "buyerTracking.submitted",
                    "type": "String"
                  }
                ],
                "concreteType": "TransactionConnection",
                "name": "transactions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "totalResults",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": "confirmedTransactionsMostRecent",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "buyerId",
                    "variableName": "userIds",
                    "type": "[String]"
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1,
                    "type": "Int"
                  },
                  {
                    "kind": "Literal",
                    "name": "sort",
                    "value": "createdDate asc",
                    "type": "String"
                  },
                  {
                    "kind": "Literal",
                    "name": "viewName",
                    "value": "buyerTracking.confirmed",
                    "type": "String"
                  }
                ],
                "concreteType": "TransactionConnection",
                "name": "transactions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "totalResults",
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "TransactionEdge",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "Transaction",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "Offer",
                            "name": "mostRecentOffer",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "createdDate",
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "name": "subTotalAmount",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ConvertedAmounts",
                                    "name": "convertedAmounts",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "args": null,
                                        "name": "USD",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "id",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "id",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "userId",
                    "variableName": "userId",
                    "type": "String!"
                  }
                ],
                "concreteType": "User",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "verifiedTradeStatus",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "firstSessionDate",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "hasVipPermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "B_VIP_CHECKOUT",
                        "type": "String!"
                      }
                    ],
                    "name": "hasPermission",
                    "storageKey": "hasPermission{\"name\":\"B_VIP_CHECKOUT\"}"
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "email",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "zipCode",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "currency",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "firstName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "serviceId",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "totalMessagesToDealers",
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "TradeFirmType",
                    "name": "tradeFirm",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "serviceId",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "tier",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmLoyaltyType",
                        "name": "loyalty",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "status",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "isTrade",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "B_TRADE_CHECKOUT",
                        "type": "String!"
                      }
                    ],
                    "name": "hasPermission",
                    "storageKey": "hasPermission{\"name\":\"B_TRADE_CHECKOUT\"}"
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "code",
                        "value": "SAVE15",
                        "type": "String!"
                      }
                    ],
                    "name": "isPromoCodeEligible",
                    "storageKey": "isPromoCodeEligible{\"code\":\"SAVE15\"}"
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "isVip",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "createdDate",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "isVerifiedTrade",
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Summary",
                    "name": "conversationSummary",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "totalUnreadConversationCount",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "showMarketingMessages",
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "type": "User",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "verifiedTradeSubStatus",
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "type": "Viewer",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": "tradeChatEmail",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "relationshipType",
                        "value": "VIP",
                        "type": "relationshipType!"
                      },
                      {
                        "kind": "Variable",
                        "name": "userIds",
                        "variableName": "userIds",
                        "type": "[String]!"
                      }
                    ],
                    "concreteType": "UserRelationship",
                    "name": "userRelationships",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "name": "userDataB",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "__typename",
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "VipRepData",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "email",
                                "storageKey": null
                              }
                            ]
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": "vipChatEmail",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "relationshipType",
                        "value": "TRADE",
                        "type": "relationshipType!"
                      },
                      {
                        "kind": "Variable",
                        "name": "userIds",
                        "variableName": "userIds",
                        "type": "[String]!"
                      }
                    ],
                    "concreteType": "UserRelationship",
                    "name": "userRelationships",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "name": "userDataB",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "__typename",
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "TradeRepData",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "email",
                                "storageKey": null
                              }
                            ]
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "query HeaderRefetchQuery(\n  $userId: String!\n  $userIds: [String]!\n  $hasUserId: Boolean!\n  $showMarketingMessages: Boolean!\n  $fetchMarketingMessagesTransactions: Boolean!\n) {\n  viewer {\n    ...Header_viewer\n    id\n  }\n}\n\nfragment Header_viewer on Viewer {\n  ...TopBar_viewer\n  allTransactions: transactions(buyerId: $userIds, first: 0) @include(if: $hasUserId) {\n    totalResults\n  }\n  initiatedTransactions: transactions(buyerId: $userIds, viewName: \"buyerTracking.initiated\", first: 0) @include(if: $hasUserId) {\n    totalResults\n  }\n  submittedTransactions: transactions(buyerId: $userIds, viewName: \"buyerTracking.submitted\", first: 0) @include(if: $hasUserId) {\n    totalResults\n  }\n  confirmedTransactionsMostRecent: transactions(buyerId: $userIds, sort: \"createdDate asc\", viewName: \"buyerTracking.confirmed\", first: 1) @include(if: $hasUserId) {\n    totalResults\n    edges {\n      node {\n        mostRecentOffer {\n          createdDate\n          subTotalAmount {\n            convertedAmounts {\n              USD\n            }\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n  ... on Viewer @include(if: $hasUserId) {\n    tradeChatEmail: userRelationships(userIds: $userIds, relationshipType: VIP) {\n      userDataB {\n        __typename\n        ... on VipRepData {\n          email\n        }\n      }\n      id\n    }\n    vipChatEmail: userRelationships(userIds: $userIds, relationshipType: TRADE) {\n      userDataB {\n        __typename\n        ... on TradeRepData {\n          email\n        }\n      }\n      id\n    }\n  }\n  user(userId: $userId) @include(if: $hasUserId) {\n    firstSessionDate\n    isTrade: hasPermission(name: \"B_TRADE_CHECKOUT\")\n    hasVipPermission: hasPermission(name: \"B_VIP_CHECKOUT\")\n    profile {\n      email\n      zipCode\n      currency\n    }\n    serviceId\n    totalMessagesToDealers\n    tradeFirm {\n      serviceId\n      tier\n      id\n    }\n    verifiedTradeStatus\n    isPromoCodeEligible(code: \"SAVE15\")\n    isVip\n    createdDate\n    isVerifiedTrade\n    ... on User @include(if: $showMarketingMessages) {\n      ...MessageBanner_user\n    }\n    ...TopBar_user\n    id\n  }\n  ... on Viewer @include(if: $showMarketingMessages) {\n    ...MessageBanner_viewer\n  }\n}\n\nfragment TopBar_viewer on Viewer {\n  ...CartNav_viewer\n  ...Notifications_initialViewer\n}\n\nfragment MessageBanner_user on User {\n  isVip\n  isVerifiedTrade\n  verifiedTradeStatus\n  verifiedTradeSubStatus\n  tradeFirm {\n    loyalty {\n      status\n    }\n    id\n  }\n}\n\nfragment TopBar_user on User {\n  ...AccountNav_user\n  ...CartNav_user\n  ...Notifications_user\n}\n\nfragment MessageBanner_viewer on Viewer {\n  allTransactions: transactions(buyerId: $userIds, first: 0) @include(if: $fetchMarketingMessagesTransactions) {\n    totalResults\n  }\n  initiatedTransactions: transactions(buyerId: $userIds, viewName: \"buyerTracking.initiated\", first: 0) @include(if: $fetchMarketingMessagesTransactions) {\n    totalResults\n  }\n  submittedTransactions: transactions(buyerId: $userIds, viewName: \"buyerTracking.submitted\", first: 0) @include(if: $fetchMarketingMessagesTransactions) {\n    totalResults\n  }\n  confirmedTransactions: transactions(buyerId: $userIds, sort: \"createdDate asc\", viewName: \"buyerTracking.confirmed\", first: 0) @include(if: $fetchMarketingMessagesTransactions) {\n    totalResults\n  }\n}\n\nfragment AccountNav_user on User {\n  profile {\n    firstName\n  }\n  conversationSummary {\n    totalUnreadConversationCount\n  }\n  tradeFirm {\n    loyalty {\n      status\n    }\n    id\n  }\n}\n\nfragment CartNav_user on User {\n  profile {\n    currency\n  }\n}\n\nfragment Notifications_user on User {\n  isPromoCodeEligible(code: \"SAVE15\")\n}\n\nfragment CartNav_viewer on Viewer {\n  portfolios(userIds: $userIds, portfolioTypes: [CART], first: 1) @include(if: $hasUserId) {\n    edges {\n      node {\n        items(first: 3) {\n          totalResults\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment Notifications_initialViewer on Viewer {\n  conversations(filter: \"showUnreadOnly\") @include(if: $hasUserId) {\n    metadata {\n      lastUnreadMessageDate\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/components/Header/__generated__/HeaderRefetchQuery.graphql.js